var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE17D",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.774 48.226c-14.36 0-26-11.64-26-26A25.887 25.887 0 0 1 9.601 5.827C3.744 10.595 0 17.86 0 26c0 14.36 11.64 26 26 26 8.141 0 15.405-3.744 20.173-9.602a25.888 25.888 0 0 1-16.399 5.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.452 52c.922 0 1.677-.755 1.677-1.678 0-.922-.755-1.677-1.677-1.677h.838c.923 0 1.678-.755 1.678-1.677 0-.923-.755-1.678-1.678-1.678h.839c.923 0 1.677-.755 1.677-1.677 0-.923-.754-1.678-1.677-1.678h9.226a1.677 1.677 0 0 0 0-3.355H14.258a2.516 2.516 0 0 1-2.516-2.515v-5.033a1.677 1.677 0 0 0-3.355 0v4.106a5.032 5.032 0 0 1-1.103 3.144l-.781.977a6.71 6.71 0 0 0-1.47 4.191v3.518A5.032 5.032 0 0 0 10.063 52h8.388z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC350"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.129 50.322H10.065a3.359 3.359 0 0 1-3.355-3.354V43.45a5.05 5.05 0 0 1 1.102-3.143l.782-.978a6.734 6.734 0 0 0 1.47-4.191v-5.783c-.926 0-1.677.75-1.677 1.677v4.106a5.033 5.033 0 0 1-1.103 3.144l-.781.977a6.71 6.71 0 0 0-1.47 4.191v3.518A5.032 5.032 0 0 0 10.064 52h8.387c.922 0 1.677-.755 1.677-1.678zM31.032 40.258H19.29a.839.839 0 1 0 0 1.677H29.355c.926 0 1.677-.75 1.677-1.677zM17.613 44.451c0 .464.375.84.839.84h1.677c.923 0 1.677-.756 1.677-1.678h-3.354a.839.839 0 0 0-.84.838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.774 47.806c0 .464.376.84.839.84h1.677c.923 0 1.678-.756 1.678-1.678h-3.355a.839.839 0 0 0-.839.838z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#AA7346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.192 34.597c-.158 0-.319-.036-.47-.113-.058-.028-5.808-2.887-12.165-3.032a1.049 1.049 0 0 1-1.024-1.073c.013-.578.493-1.058 1.072-1.023 6.844.156 12.81 3.13 13.061 3.257a1.048 1.048 0 0 1-.474 1.984zM19.29 13.63c-.23 0-.46-.075-.652-.229-.158-.124-3.764-2.891-8.105-.721a1.049 1.049 0 0 1-.937-1.876c5.568-2.786 10.157.804 10.35.958a1.049 1.049 0 0 1-.657 1.867zM31.031 15.307a1.05 1.05 0 0 1-.204-2.077l8.387-1.677a1.048 1.048 0 1 1 .411 2.056l-8.387 1.677c-.07.014-.139.02-.207.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.438 21.127a2.097 2.097 0 0 1-1.824-2.338l.205-1.665a2.097 2.097 0 0 1 4.162.513l-.205 1.665a2.097 2.097 0 0 1-2.338 1.825z",
    fill: "#7D5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.156 15.3a2.103 2.103 0 0 0-.421-.01l-.354 2.872a1.258 1.258 0 1 0 2.497.308l.103-.832a2.097 2.097 0 0 0-1.825-2.338z",
    fill: "#9C6846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.999 22.961a2.097 2.097 0 0 1-1.825-2.337l.205-1.665a2.097 2.097 0 0 1 4.162.513l-.205 1.665A2.097 2.097 0 0 1 33 22.96z",
    fill: "#7D5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.717 17.135a2.103 2.103 0 0 0-.422-.01l-.354 2.872a1.258 1.258 0 1 0 2.498.308l.102-.833a2.097 2.097 0 0 0-1.824-2.337z",
    fill: "#9C6846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.5272afba.svg";
export { ForwardRef as ReactComponent };